import React from 'react';
import { Link } from 'react-router-dom';

export default ({ icono = null, url, region, imagen, texto }) => (
    <Link to={url}>
        <div className={`boton_bonito ${region}`}
             style={{ 'backgroundImage': `url(${imagen})` }}>
            {icono && <div className='icono'><img src={icono} alt=''/></div>}
            <div className='texto'>{texto}</div>
        </div>
    </Link>
);


// WEBPACK FOOTER //
// ./src/components/BotonBonito.js